import {
    GET_ADJUSTMENT_ACCOUNT_REQUEST,
    GET_ADJUSTMENT_ACCOUNT_SUCCESS,
    GET_ADJUSTMENT_ACCOUNT_ERROR,


} from "./types"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"


///GET CUSTOMER TYPE
export const getNewAdjustmentAccount = (token) => dispatch => {
    dispatch({ type: GET_ADJUSTMENT_ACCOUNT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getAccountForStockAdjustment`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_ADJUSTMENT_ACCOUNT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_ADJUSTMENT_ACCOUNT_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_ADJUSTMENT_ACCOUNT_ERROR,
                payload: error.response,
            });
        })
};

